

import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
import { uuid4 } from "@sentry/utils";
import { useLocation, useHistory } from "react-router-dom";
import { useCookieConsent } from '../context/CookieConsentContext';
import { SENTRY_URL } from '../config';
const ErrorReportButton = () => {
    const { preferences, openPreferences } = useCookieConsent();

    const [debug, setDebug] = useState(false);
    let location = useLocation()
    let history = useHistory()

    useEffect(() => {
        if( localStorage.getItem('Webinardebug')){
            setDebug(true);
        }
        else{
            setDebug(false);
        }
    }, [location])


    const errore = () => {
        if (!preferences.diagnostics) { openPreferences(); return; }
        if (!SENTRY_URL) return;
        localStorage.removeItem('Webinardebug');
        let code = uuid4();
        Sentry.captureException(code);
        history.push('/', {'successReason': 'segnalazione inviata, comunica questo codice a infoceformedsrl@gmail.com: '+ code});
    }
    
    return  (
    <div>
        {debug  ? <button onClick={errore}>Invia segnalazione errore</button> : null}
    </div>
    )
};

export default ErrorReportButton;

